import React from "react";

const PageHead = ({ num, label, line1, line2, lead, children }) => (
  <header className="page-head">
    <div className="page-head__row">
      <div>
        <div className="sec reveal">
          {num && <span className="sec__num">{num}</span>}
          <span className="eyebrow">— {label}</span>
        </div>
        <h1>
          <span className="mask">
            <span>{line1}</span>
          </span>
          {line2 && (
            <span className="mask">
              <span className="ink-italic" style={{ animationDelay: "0.1s" }}>
                {line2}
              </span>
            </span>
          )}
        </h1>
        {lead && (
          <p className="reveal" style={{ animationDelay: "0.2s" }}>
            {lead}
          </p>
        )}
      </div>
      {children && (
        <div className="reveal" style={{ animationDelay: "0.25s" }}>
          {children}
        </div>
      )}
    </div>
  </header>
);

export default PageHead;
